/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TranslationSearchOrderBy {
    Default = 'Default'
}


export function instanceOfTranslationSearchOrderBy(value: any): boolean {
    for (const key in TranslationSearchOrderBy) {
        if (Object.prototype.hasOwnProperty.call(TranslationSearchOrderBy, key)) {
            if (TranslationSearchOrderBy[key as keyof typeof TranslationSearchOrderBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TranslationSearchOrderByFromJSON(json: any): TranslationSearchOrderBy {
    return TranslationSearchOrderByFromJSONTyped(json, false);
}

export function TranslationSearchOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationSearchOrderBy {
    return json as TranslationSearchOrderBy;
}

export function TranslationSearchOrderByToJSON(value?: TranslationSearchOrderBy | null): any {
    return value as any;
}

export function TranslationSearchOrderByToJSONTyped(value: any, ignoreDiscriminator: boolean): TranslationSearchOrderBy {
    return value as TranslationSearchOrderBy;
}

